import React, { useEffect, useState } from 'react';
import { notification, Spin, Transfer } from 'antd';
import { useGetManagementCompanies } from 'hooks/useGetManagementCompanies';
import { MGCompanyListResponse } from 'services/parametersService';
import { useDisplayFrameworkContext } from 'DisplayFramework/hooks/useDisplayFrameworkContext';
import { useTransfer } from 'hooks/useTransfer';
import {
  MgParAssetCatalog,
  addMgParAssetCatalog,
  getMgParAssetCatalogByCatalogid,
  removeMgParAssetCatalog,
} from 'services/assetconfig';
import { useQuery } from 'react-query';

type AssetCatalogAuthorizedCompaniesTransferProps = {
  asset?: any;
  catalogid: number;
};

const AssetCatalogAuthCompanies = (
  props: AssetCatalogAuthorizedCompaniesTransferProps
) => {
  const { getComponentLabel } = useDisplayFrameworkContext();
  const availableValuesLabel = getComponentLabel('availableValues');
  const associatedValuesLabel = getComponentLabel('associatedValues');
  const { catalogid } = props;
  const { data: mgList } = useGetManagementCompanies();
  const { onSelectChange, selectedKeys } = useTransfer();

  const [isLoading, setisLoading] = useState(false);

  // const initialTargetKeys = mgUsersList?.map((mgUser) => String(mgUser.mgid));
  const [targetKeys, setTargetKeys] = useState<string[]>([]);
  const [datasource, setDataSource] = useState<MGCompanyListResponse[]>([]);

  const { data: authComp, refetch } = useQuery(
    ['getMgParAssetCatalogByCatalogid'],
    () =>
      getMgParAssetCatalogByCatalogid({ catalogid: catalogid }).then(
        (res) => res.list || []
      ),
    {
      enabled: !!catalogid,
    }
  );

  const onChange = (
    nextTargetKeys: string[],
    direction: string,
    moveKeys: string[]
  ) => {
    let promises: Array<Promise<any>> = [];
    // eslint-disable-next-line array-callback-return
    moveKeys.forEach((key: string) => {
      let requestPayload: MgParAssetCatalog = {
        catalogid: catalogid,
        filterid: 0,
        mgid: Number(key),
      };
      const filterId =Number ((authComp?.find((e: any) => e.mgid === Number(key)))?.filterid);
   

      setisLoading(true);
      if (direction === 'right') {
        promises.push(
          addMgParAssetCatalog({
            catalogid: catalogid,
            request: requestPayload,
          })
            .then((response: any) => {
              setisLoading(false);
              if (response.code === '200') {
                notification.success({
                  message: response.message,
                });
                refetch();
              } else {
                notification.error({
                  message: response.message,
                });
              }
            })
            .catch(() => {
              setisLoading(false);
            })
        );
      } else {
        setisLoading(true);
        promises.push(
          removeMgParAssetCatalog({
            catalogid: catalogid,
            filterid: filterId ? filterId : 0,
          }).then((response: any) => {
            refetch();
            setisLoading(false);

            if (response.code === '200') {
              notification.success({
                message: response.message,
              });
            } else {
              notification.error({
                message: response.message,
              });
            }
          })
        );
      }
      return catalogid;
    });
    Promise.all(promises).then((response) => {
      refetch();
    });
  };

  useEffect(() => {
    if (authComp && mgList) {
      setDataSource(mgList);
      setTargetKeys(authComp?.map((auth) => String(auth.mgid)));
    }
  }, [authComp, mgList]);

  return (
    <Spin spinning={isLoading}>
      <Transfer
        dataSource={datasource}
        showSearch
        onChange={onChange}
        // disabled={isCreate}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        onSelectChange={onSelectChange}
        render={(item) => item.mgname}
        titles={[availableValuesLabel, associatedValuesLabel]}
        rowKey={(mg) => String(mg.mgid)}
        listStyle={{
          width: 300,
          height: 300,
        }}
      />
    </Spin>
  );
};

export default AssetCatalogAuthCompanies;
